import * as Core from '../core';

export class ClassSessionService {
    public static async list(organizationId: string): Promise<Core.Models.ClassSession[]> {
        const route = Core.API.ServerRoute.forAction('classSessions');
        return Core.API.get(route, undefined, { organizationId });
    }

    public static async create(request: {
        organizationId: string;
        topicId: string;
        startTimeUtc: string;
        hostNotes?: string;
    }): Promise<Core.Models.ClassSession> {
        const route = Core.API.ServerRoute.forAction('classSessions');
        return Core.API.post(route, request);
    }

    public static async join(matchId: string): Promise<void> {
        const route = Core.API.ServerRoute.forAction('classSessions', `${matchId}/join`);
        return Core.API.post(route, {});
    }

    public static async delete(matchId: string): Promise<void> {
        const route = Core.API.ServerRoute.forAction('classSessions', matchId);
        return Core.API.delete(route);
    }

    public static async ensureCatalog(): Promise<void> {
        const route = Core.API.ServerRoute.forAction('classSessions', 'catalog/ensure');
        return Core.API.post(route, {});
    }

    public static async getCatalogGames(): Promise<Core.Models.QuizWhizzerCatalogGame[]> {
        const route = Core.API.ServerRoute.forAction('classSessions', 'catalog/games');
        return Core.API.get(route);
    }

    public static async getTopics(gameId?: string): Promise<Core.Models.QuizWhizzerTopic[]> {
        const route = Core.API.ServerRoute.forAction('classSessions', 'catalog/topics');
        return Core.API.get(route, undefined, gameId ? { gameId } : undefined);
    }

    public static async importTopics(gameId: string, csvContent: string): Promise<number> {
        const route = Core.API.ServerRoute.forAction('classSessions', 'catalog/topics/import');
        return Core.API.post(route, { gameId, csvContent });
    }

    public static async upsertTopic(
        topic: Partial<Core.Models.QuizWhizzerTopic> & {
            gameId: string;
            subject: string;
            subjectSlug: string;
            topic: string;
            launchUrl: string;
        }
    ): Promise<Core.Models.QuizWhizzerTopic> {
        const route = Core.API.ServerRoute.forAction('classSessions', 'catalog/topics');
        return Core.API.post(route, topic);
    }

    public static async deleteTopic(id: string): Promise<void> {
        const route = Core.API.ServerRoute.forAction('classSessions', `catalog/topics/${id}`);
        return Core.API.delete(route);
    }

    public static async deleteAllTopics(gameId: string): Promise<number> {
        const route = Core.API.ServerRoute.forAction('classSessions', `catalog/games/${gameId}/topics`);
        return Core.API.delete(route);
    }
}
